
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import { createServerContext } from "@/script/apps/device/config/DeviceConfig";
import { Server, ServerConfig } from "@/script/apps/device/entity/DeviceEntity";
import { ServerService } from "@/script/apps/device/service/ServerService";

@Options({})
export default class ServerDetail extends BaseDetail {
  public initData(): ServiceContext {
    return createServerContext();
  }

  public newEntity() {
    const entity: Server = {};
    return entity;
  }

  public afterLoad(data: any) {
    const server = this.entity as Server;
    server.deleteServerConfigs = [];
    this.injectDetailData(server.serverConfigs!, server.deleteServerConfigs!);
    this.generateRowNo();
  }

  public test() {
    (createServerContext().service as ServerService).test((data: string) => {
      ElMessage({ type: "success", message: "连接成功" });
    });
  }

  public addRow() {
    const server = this.entity as Server;
    const serverConfig: ServerConfig = {};
    serverConfig.application = server.serviceName;
    serverConfig.label = "master";
    serverConfig.profile = "dev";
    this.addListRow(server.serverConfigs!, serverConfig);
  }
}
